"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryDropdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _dropdownCore = require("../../dropdown-core");

var _getClassesPropType = require("../../../helpers/getClassesPropType");

var _useStyles = require("../../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c828745c2{position:relative;box-shadow:var(--box-sh-main-def)}.c828745c2:before{content:'';border-radius:.0625rem;position:absolute;-webkit-transform:rotate(45deg);transform:rotate(45deg);width:.625rem;height:.625rem;z-index:1}.c828745c2:not(.c48d8da2e) .c21e2393a{max-height:22rem;overflow:auto}.c21e2393a{position:relative;z-index:2}.ce0754756{background:#fff;border-radius:var(--border-radius-def);display:flex;flex-direction:column;width:auto;padding:var(--border-radius-def) 0}.ce0754756:before{background:#fff}.cb964f3a0{background:var(--color-flomni-gray-70);border-radius:.5rem;padding:.625rem .9375rem .6875rem;color:#fff;font-size:.875rem;font-weight:400;line-height:1.25rem;box-sizing:border-box;max-width:15.625rem}.cb964f3a0:before{background:var(--color-flomni-gray-70)}.cfba2425b{background:#fff;border-radius:var(--border-radius-def);display:flex;flex-direction:column;width:auto;padding:var(--border-radius-def) 0}.cfba2425b:before{display:none}.cfba2425b.c97de9ba2{margin-top:.0625rem}.cfba2425b.c41b516c3{margin-bottom:.0625rem}.c3f24bd8a:before{left:1rem}.c6451cb91:before{right:1rem}.c97de9ba2{margin-top:.6875rem}.c97de9ba2:before{top:-.3rem}.c41b516c3{margin-bottom:.6875rem}.c41b516c3:before{bottom:-.3rem}");
var styles = {
  root: 'c828745c2',
  '--no-scroll': 'c48d8da2e',
  content: 'c21e2393a',
  '--view-usual': 'ce0754756',
  '--view-tooltip': 'cb964f3a0',
  '--view-arrowless': 'cfba2425b',
  '--direction-down': 'c97de9ba2',
  '--direction-up': 'c41b516c3',
  '--position-left': 'c3f24bd8a',
  '--position-right': 'c6451cb91'
};

var PrimaryDropdown = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var onOverlayClick = props.onOverlayClick,
      children = props.children,
      active = props.active,
      classes = props.classes,
      position = props.position,
      direction = props.direction,
      dropdownCoreProps = props.dropdownCoreProps,
      noScroll = props.noScroll,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement(_dropdownCore.DropdownCore, (0, _extends2.default)({
    ref: ref,
    active: active,
    onOverlayClick: onOverlayClick,
    position: position,
    direction: direction
  }, dropdownCoreProps), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.position[position], cn.direction[direction], cn.view[view], (0, _defineProperty2.default)({}, cn.no.scroll, noScroll))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, children)));
});

exports.PrimaryDropdown = PrimaryDropdown;
var position = ['left', 'right'];
var direction = ['down', 'up'];
var view = ['usual', 'tooltip', 'arrowless'];
PrimaryDropdown.modes = {
  position: position,
  direction: direction,
  view: view
};
PrimaryDropdown.propTypes = {
  /* component logic props */
  onOverlayClick: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  dropdownCoreProps: _propTypes.object,

  /* styling modificators */
  position: (0, _propTypes.oneOf)(position),
  direction: (0, _propTypes.oneOf)(direction),
  view: (0, _propTypes.oneOf)(view),
  noScroll: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryDropdown.defaultProps = {
  position: 'left',
  direction: 'down',
  view: 'usual',
  active: false,
  noScroll: false,
  classes: {},
  dropdownCoreProps: {}
};